<script setup>
import { provide } from 'vue'
import { useId } from 'radix-vue'
import { FORM_ITEM_INJECTION_KEY } from './injectionKeys'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
  id: { type: String, required: false },
})

const id = props.id || useId()
provide(FORM_ITEM_INJECTION_KEY, id)
</script>

<template>
  <div :class="props.class">
    <slot />
  </div>
</template>
